import { css, cx } from '@linaria/core'
import type { FC } from 'react'
import { pageHeaderSlotOrder } from './PageHeaderSlotOrder'
import { usePageHeaderContext } from './usePageHeaderContext'

const pageHeaderSlotClass = css`
  display: flex;
  order: -10;
  flex: 1;
  flex-basis: 0;
  flex-basis: auto;
  overflow: hidden;
  box-sizing: content-box;
  justify-content: end;
  align-items: stretch;

  > ._left {
    order: ${pageHeaderSlotOrder.left};
    height: 100%;
    display: flex;
  }

  > ._center {
    order: ${pageHeaderSlotOrder.center};
    flex: 1;
    height: 100%;
    display: flex;
  }

  > ._right {
    order: ${pageHeaderSlotOrder.right};
    display: flex;
    flex-wrap: nowrap;
  }
`

export const PageHeaderSlots: FC<{ className?: string }> = ({ className }) => {
  const { setBaseRoot, setHomeRoot, setTabsRoot, setToolsRoot } = usePageHeaderContext()
  return (
    <div className={cx(className, pageHeaderSlotClass)} ref={setBaseRoot}>
      <div className="_left" ref={setHomeRoot} />
      <div className="_center" ref={setTabsRoot} />
      <div className="_right" ref={setToolsRoot} />
    </div>
  )
}
